"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BAR_NOTIFICATION_FOOTER_HEIGHT = exports.APP_BAR_NOTIFICATION_MAX_HEIGHT_POPOVER = exports.APP_BAR_NOTIFICATION_MAX_WIDTH_POPOVER = void 0;
exports.APP_BAR_NOTIFICATION_MAX_WIDTH_POPOVER = 720;
exports.APP_BAR_NOTIFICATION_MAX_HEIGHT_POPOVER = 640;
exports.APP_BAR_NOTIFICATION_FOOTER_HEIGHT = 49;
//# sourceMappingURL=constants.js.map